'use client';
import Link from 'next/link';
import { cn } from '@/lib/utils';
import { BlogRelatedExperienceMedia } from '@/types/Blog';
import { experienceMap, sicilyMap } from '@/utils/maps';
import './styles.css';
import Image from 'next/image';
import getMediaFilterUrl from '@/utils/get-media-filter';
import CreateMediaFilterTrigger from '@/components/Media/CreateMediaFilterTrigger';

type Props = {
  translation: {
    title: string;
    description: string;
    locale: string;
    slug: string;
  };
  image: BlogRelatedExperienceMedia;
  lang: string;
  macroCategoryTranslation: {
    locale: string;
    slug: string;
  };
};

export default function BlogArticleExperiencesCarouselCard({
  translation,
  image,
  lang,
  macroCategoryTranslation,
}: Props) {
  const imagePathWithFilename = `${image.path}${image.filename}`;

  const filterName = 'vertical_slider_2x_webp';

  const filteredImageSource = getMediaFilterUrl({
    mediaFilters: image?.mediaFilters,
    filterName,
  });

  function getUrl() {
    let langString = '';
    let sicilyTranslation = 'sicily';
    let experiencesTranslation = 'experiences';
    const macroCategoryCodeSlug = macroCategoryTranslation.slug;
    const categorySlug = translation.slug;

    if (lang !== 'en') {
      langString = `/${lang}`;
      sicilyTranslation = sicilyMap[lang];
      experiencesTranslation = experienceMap[lang];
    }

    return `${langString}/${sicilyTranslation}/${experiencesTranslation}/${macroCategoryCodeSlug}/${categorySlug}`;
  }

  return (
    <Link className={cn('c-card', '')} href={getUrl()}>
      <CreateMediaFilterTrigger
        imageUrl={filteredImageSource}
        mediaId={image?.id}
        filterName={filterName}
      />
      <div className="c-card_bg">
        <Image
          src={
            filteredImageSource ??
            `https://villatravellers-prod.s3.amazonaws.com/thumbs/${filterName}/${imagePathWithFilename}`
          }
          alt={translation.title}
          fill
          className=""
          sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
          style={{
            objectFit: 'cover',
          }}
        />
      </div>
      <div className="c-card_content">
        <h3 className="mb-2 mt-0 relative font-semibold text-xl text-center">
          {translation.title}
        </h3>
        <div
          className="card-subtitle overflow-hidden mt-[20px] h-[96px] relative text-base text-center [&>p]:mb-8"
          dangerouslySetInnerHTML={{ __html: translation.description }}
        />
      </div>
    </Link>
  );
}
